import api from "../utils/api";
import _ from "lodash";

export const getBookingTimeSlots = async (workorderid, fromdate, todate) => {
  const { data } = await api.booking.availableTimeSlot.getAll({
    workorderid,
    fromdate,
    todate
  });
  if (!data) {
    return [];
  }
  const { availableResources } = data;
  if (availableResources.length === 0) {
    return [];
  }
  const { availableDateTimeSubSlots: slots, resourceId } = availableResources[0];
  let result = [];
  for (let item of slots) {
    const { slotStartDateTime, slotEndDateTime, slotDate } = item;
    const [month, day, year] = slotDate.split("/").map(x => Number(x));
    const resultItem = result.find(x => x.date.year === year && x.date.month === month && x.date.day === day);
    const startTime = slotStartDateTime.substr(11, 5);
    const endTime = slotEndDateTime.substr(11, 5);
    const slotData = {
      startTime,
      endTime,
      label: `${startTime} - ${endTime}`,
      value: `${slotStartDateTime} ${slotEndDateTime} ${resourceId}`
    };
    if (resultItem) {
      resultItem.timeSlots.push(slotData);
    } else {
      result.push({
        date: { day, month, year },
        timeSlots: [slotData]
      });
    }
  }
  return result;
};
